// @ts-nocheck
import React from "react";
import { HyperPayCopyAndPayWidget } from "./HyperPayCopyAndPayWidget";

export interface HyperPayConfig {
  checkoutId?: string;
  widgetBaseUrl?: string;
  return_url?: string;
  checkoutIntegrity?: string | null;
  wpwlOptions?: Record<string, unknown>;
  /** Wallet standalone registration — no charge. */
  registration?: boolean;
}

interface HyperPayPaymentFormProps {
  config: HyperPayConfig;
  scriptId?: string;
  /** OPPWA COPYandPAY `data-brands` (e.g. MADA, VISA, or VISA MASTER for one card form). */
  dataBrands?: string;
  /** Separate OPPWA checkout for card vs Apple Pay (different channel entities on server). */
  variant?: "card" | "applepay";
  /** Placed directly above the OPPWA Pay button (card checkout only). */
  abovePayButtonSlot?: React.ReactNode;
  getSaveCardForSubmit?: () => boolean;
  /** Flatten inner OPPWA card chrome when rendered inside AppModal. */
  inModal?: boolean;
  /** One unified card form — hide Mada/Visa/Master tabs. */
  hideBrandSelector?: boolean;
}

/**
 * HyperPay payment form - COPYandPAY only (no server-to-server).
 * Card data goes directly to HyperPay via PCI SAQ-A compliant widget.
 */
export const HyperPayPaymentForm: React.FC<HyperPayPaymentFormProps> = ({
  config,
  scriptId = "hyperpay-widget-script",
  dataBrands,
  variant = "card",
  abovePayButtonSlot,
  getSaveCardForSubmit,
  inModal = false,
  hideBrandSelector = false,
}) => {
  if (!config?.checkoutId || !config?.widgetBaseUrl || !config?.return_url) {
    return null;
  }

  return (
    <HyperPayCopyAndPayWidget
      config={{
        checkoutId: config.checkoutId,
        widgetBaseUrl: config.widgetBaseUrl,
        return_url: config.return_url,
        integrity: config.checkoutIntegrity,
        wpwlOptions: config.wpwlOptions,
        registrationCheckout: !!config.registration,
      }}
      scriptId={scriptId}
      dataBrands={dataBrands}
      variant={variant}
      abovePayButtonSlot={variant === "card" ? abovePayButtonSlot : undefined}
      getSaveCardForSubmit={variant === "card" ? getSaveCardForSubmit : undefined}
      inModal={inModal}
      hideBrandSelector={hideBrandSelector}
    />
  );
};

export default HyperPayPaymentForm;
